function EventSignupModal(el) {
    this.el = el;
    this.init();
}

EventSignupModal.prototype.init = function() {
    document.body.addEventListener('click', (e) => {
        if (e.target.classList.contains('jsTriggerEventSignupModal')) {
            e.preventDefault();
            this.open();
        }
    });

    this.el.addEventListener('click', (e) => {
        if (e.target.classList.contains('jsClose')) {
            e.preventDefault();
            this.close();
        }
    });

    window.addEventListener('keyup', (e) => {
        if (e.key.toLowerCase() === 'escape') {
            this.close();
        }
    });
};

EventSignupModal.prototype.open = function() {
    this.el.classList.add('is-active');
};

EventSignupModal.prototype.close = function() {
    this.el.classList.remove('is-active');
};

(function() {
    var eventSignupModalEl = document.querySelector('.jsEventSignupModal');
    if (eventSignupModalEl) new EventSignupModal(eventSignupModalEl);
})();
